import { useEffect, useState } from "react";
import { Box, IconButton, Switch } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import TableComponent from "../../components/TableComponent";
import { useNavigate } from "react-router-dom";
import { ENUM_ROUTES } from "../../RoutesEnum";
import { useLazyGetPointsQuery } from "../../services/loyaltyPoint";

const LoyaltyPointsList = () => {
  const [open, setOpen] = useState(false);
  const label = { inputProps: { "aria-label": "Toggle status" } };
  const navigate = useNavigate();

  const [rows, setRows] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [getPoints] = useLazyGetPointsQuery();

  const fetchPoints = async () => {
    try {
      setLoading(true);
      const response = await getPoints({ from: page, size: pageSize, search: "" }).unwrap();
      if (response?.statusCode === 200) {
        setRows(response.data?.data || []);
        setTotalCount(response.data?.total || 0);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPoints();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const columns: GridColDef<any>[] = [
    {
      field: "hostDetails",
      headerName: "Host Details",
      flex: 1,
      minWidth: 240,
      sortable: false,
      renderCell: ({ row }) => {
        const details = row?.userDetails || row?.ownerDetails || row?.hostDetails || {};
        const firstName = details?.firstName || "";
        const lastName = details?.lastName || "";
        const fullName = `${firstName} ${lastName}`.trim() || "-";
        const email = details?.email || "-";
        const avatar = details?.image || "/static/images/user_placeholder.png";
        const hostId = details?._id;
        return (
          <div
            className="user_block click_action"
            onClick={() => hostId && navigate(`/manage-owner/detail/${hostId}`)}
          >
            <figure>
              <img src={avatar} alt="" />
            </figure>
            <p>
              <b>{fullName}</b> <span>{email}</span>
            </p>
          </div>
        );
      },
    },
    {
      field: "value",
      headerName: "Price Per Loyalty Point",
      flex: 1,
      minWidth: 200,
      sortable: false,
      valueGetter: (params) => params.row?.value ?? "-",
    },
    {
      field: "pointPerOrder",
      headerName: "Redemption Limit",
      flex: 1,
      minWidth: 180,
      sortable: false,
      valueGetter: (params) => params.row?.pointPerOrder ?? "-",
    },
    {
      field: "minimumPurchase",
      headerName: "Minimum Purchase to Redeem Points",
      flex: 1.5,
      minWidth: 260,
      sortable: false,
      valueGetter: (params) => params.row?.minimumPurchase ?? "-",
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   flex: 1,
    //   minWidth: 100,
    //   align: "center",
    //   headerAlign: "center",
    //   sortable: false,
    //   renderCell: (params) => <Switch {...label} checked={!!params.row?.status} />,
    // },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => (
        <Box className="table_actions v2" display="flex" gap={1}>
          {/* <IconButton onClick={() => navigate(`${ENUM_ROUTES.LOYALTY_POINTS_DETAILS}/${params.row?._id}`)}>
            <img src="/static/images/eye_icon.svg" alt="" />
          </IconButton> */}
          <IconButton onClick={() => navigate(`/manage-loyalty-points/edit/${params.row?._id}`)}>
            <img src="/static/images/edit2_icon.svg" alt="Edit" />
          </IconButton>
          <IconButton>
            <img src="/static/images/trash2_icon.svg" alt="Delete" />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <div className="sorting_table">
      <TableComponent
        columns={columns}
        rows={rows}
        count={totalCount}
        page={page}
        onPageChange={(e: any, newPage: number) => setPage(newPage)}
        loading={loading}
        getRowId={(row: any) => row?._id}
      />
    </div>
  );
};

export default LoyaltyPointsList;
